// Agent detail page + memory settings rows (WEB-8003). AgentConfig
// feature styles (WEB-7961 folder). Composed by workspaceStyles.ts in place.
export const agentConfigPage = `
/* ===== Agent page ===== */
.ws-agent-page {
  flex: 1; overflow: auto;
}
.ws-agent-page-inner {
  padding: 12px 40px 60px;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}
.ws-mission-split {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: start;
}
.ws-agent-hero { display: flex; gap: 10px; align-items: center; margin-bottom: 0; }
.ws-agent-hero-sw {
  width: 28px; height: 28px; border-radius: 7px;
  display: grid; place-items: center;
  color: white;
  font-family: var(--ws-serif); font-weight: 600; font-size: 13px;
  overflow: hidden; flex-shrink: 0;
}
.ws-agent-hero-sw:has(img) { background: transparent !important; }
.ws-agent-hero-name {
  font-family: var(--ws-serif);
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--ws-ink);
  line-height: 1.1;
}

.ws-agent-hero-actions {
  display: flex; gap: 6px; align-items: center; margin-left: auto;
}

.ws-agent-spend-inline {
  display: flex; align-items: center; gap: 8px;
  margin-left: auto; padding: 4px 10px;
  border-radius: 6px; background: var(--ws-soft);
}
.ws-agent-spend-inline.warn { background: #FEF6EE; }
.ws-agent-spend-inline.err { background: #FEF2F0; }
.ws-agent-spend-inline-text {
  font-size: 12px; font-weight: 500; color: var(--ws-ink-3);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.ws-agent-spend-inline.warn .ws-agent-spend-inline-text { color: var(--ws-warn); }
.ws-agent-spend-inline.err .ws-agent-spend-inline-text { color: var(--ws-err); }
.ws-agent-spend-inline-bar {
  width: 60px; height: 4px; background: var(--ws-line);
  border-radius: 2px; overflow: hidden;
}
.ws-agent-spend-inline-fill {
  height: 100%; border-radius: 2px; transition: width 0.2s;
}
.ws-agent-spend-inline-fill.ok { background: var(--ws-ink-3); }
.ws-agent-spend-inline-fill.warn { background: var(--ws-warn); }
.ws-agent-spend-inline-fill.err { background: var(--ws-err); }

.ws-agent-tabs {
  display: flex; gap: 20px;
  border-bottom: 1px solid var(--ws-line);
  margin: 4px 0 12px;
}
.ws-agent-tab {
  padding: 10px 2px;
  color: var(--ws-ink-4);
  font-size: 13.5px; font-weight: 500;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  border-top: 0; border-left: 0; border-right: 0;
  background: transparent;
  font-family: var(--ws-sans);
}
.ws-agent-tab:hover { color: var(--ws-ink-3); }
.ws-agent-tab.active { color: var(--ws-ink); border-bottom-color: var(--ws-ink); font-weight: 600; }

.ws-agent-section {
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-lg);
  padding: 24px 26px;
  margin-bottom: 18px;
}
.ws-agent-section h3 {
  font-family: var(--ws-serif);
  font-size: 18px; font-weight: 600;
  margin: 0 0 4px;
  color: var(--ws-ink);
  display: flex; align-items: center; gap: 8px;
  letter-spacing: -0.005em;
}
.ws-agent-section .ws-section-sub { font-size: 12.5px; color: var(--ws-ink-4); margin-bottom: 14px; }

.ws-company-profile-fields {
  display: flex; flex-direction: column; gap: 14px;
}
.ws-company-profile-field {
  display: flex; flex-direction: column; gap: 6px;
}
.ws-company-profile-field-label {
  font-size: 12.5px; font-weight: 600; color: var(--ws-ink);
}
.ws-agent-edit-textarea.ws-company-profile-textarea {
  /* Two rows until opened, then the whole text - keeps the fields from burying the library.
     No bottom padding while clipped, or the third line peeks into it. Opened by state, not
     :focus: collapsing on blur moves Save out from under the pointer mid-click. */
  min-height: 0; overflow: hidden; padding-bottom: 0;
}
.ws-company-profile-field.is-open .ws-company-profile-textarea {
  field-sizing: content; overflow: auto; padding-bottom: 8px;
}
.ws-company-profile-field-meta {
  display: none; font-size: 11.5px; color: var(--ws-ink-4); align-self: flex-end;
}
.ws-company-profile-field.is-open .ws-company-profile-field-meta { display: block; }

.ws-company-profile-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 12px; margin-bottom: 14px;
}
.ws-company-profile-header h3 { margin-bottom: 4px; }
.ws-company-profile-generate-btn {
  display: inline-flex; align-items: center; gap: 6px;
  white-space: nowrap; flex-shrink: 0;
}
.ws-company-profile-generate-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.ws-company-profile-actions {
  display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px;
}

.ws-identity-avatar-row {
  display: flex; align-items: center; gap: 14px; margin-bottom: 18px;
}
.ws-identity-avatar {
  width: 56px; height: 56px; border-radius: 14px;
  display: grid; place-items: center;
  font-family: var(--ws-serif); font-weight: 600; font-size: 24px;
  overflow: hidden; flex-shrink: 0;
}
.ws-identity-avatar:has(img) { background: transparent !important; }
.ws-identity-actions {
  display: flex; gap: 8px; justify-content: flex-end; margin-top: 6px;
}

.ws-agent-field { margin-bottom: 14px; }
.ws-agent-field-label {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4); margin-bottom: 5px;
}
.ws-agent-field-value {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 12px 14px;
  font-size: 13.5px; line-height: 1.5; color: var(--ws-ink-2);
}
.ws-agent-trust { padding: 10px 0; }
.ws-agent-trust-bar { display: flex; gap: 4px; margin-bottom: 8px; }
.ws-agent-trust-seg {
  width: 36px; height: 6px; border-radius: 3px;
  background: var(--ws-line); transition: background 0.2s;
}
.ws-agent-trust-seg.filled { background: var(--ws-ink); }
.ws-agent-trust-label { font-size: 13.5px; font-weight: 500; color: var(--ws-ink-2); }
.ws-agent-trust-sub { font-size: 12px; color: var(--ws-ink-4); margin-top: 4px; }
.ws-agent-field-value.ws-serif-quote {
  font-family: var(--ws-serif);
  font-size: 16px; font-style: italic; color: var(--ws-ink-2);
}

.ws-perm-header {
  display: grid;
  grid-template-columns: 140px repeat(4, 1fr);
  gap: 4px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
}
.ws-perm-row {
  display: grid;
  grid-template-columns: 140px repeat(4, 1fr);
  gap: 4px;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-row:last-child { border-bottom: none; }
.ws-perm-entity {
  font-size: 13px;
  color: var(--ws-ink);
  text-transform: capitalize;
}
.ws-perm-level {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ws-perm-dot {
  width: 20px; height: 20px;
  border-radius: 50%;
  border: 2px solid var(--ws-line-2);
  background: transparent;
  transition: background 0.15s, border-color 0.15s;
  display: block;
  padding: 0;
  cursor: default;
}
.ws-perm-dot--active {
  background: var(--ws-accent, #1d3d48);
  border-color: var(--ws-accent, #1d3d48);
}
.ws-perm-top-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}
.ws-perm-earn-hint {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  margin-top: 12px;
  background: var(--ws-soft);
  border-radius: var(--ws-r-sm);
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ws-ink-3);
}
.ws-perm-section-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  margin-bottom: 8px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: var(--ws-ink);
}
.ws-perm-section-title {
  font-size: 14px;
  font-weight: 600;
  font-family: var(--ws-sans);
}
.ws-perm-section-sub {
  font-size: 12px;
  color: var(--ws-ink-4);
  font-weight: 400;
  margin-left: 4px;
}
.ws-perm-cap-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}
.ws-perm-cap-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-cap-row:last-child { border-bottom: none; }
.ws-perm-cap-indicator {
  width: 10px; height: 10px;
  border-radius: 50%;
  border: 2px solid var(--ws-line-2);
  background: transparent;
  flex-shrink: 0;
}
.ws-perm-cap-indicator--active {
  background: var(--ws-ok);
  border-color: var(--ws-ok);
}
.ws-perm-cap-text {
  min-width: 0;
}
.ws-perm-cap-name {
  font-size: 13px;
  color: var(--ws-ink);
}
.ws-perm-cap-sub {
  font-size: 12px;
  color: var(--ws-ink-4);
  margin-top: 1px;
}
.ws-perm-readonly-card {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 18px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-soft);
}
.ws-perm-readonly-icon {
  width: 18px; height: 18px;
  color: var(--ws-ink-3);
  flex-shrink: 0;
  margin-top: 2px;
}
.ws-perm-readonly-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ws-ink);
  margin-bottom: 4px;
}
.ws-perm-readonly-body {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ws-ink-3);
}
.ws-perm-readonly-footer {
  margin-top: 12px;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--ws-ink-4);
  font-style: italic;
}
.ws-perm-granted-list {
  display: flex;
  flex-direction: column;
}
.ws-perm-granted-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-granted-row:last-child { border-bottom: none; }
/* WEB-9220: admin grant/revoke. The row is space-between with 2 children, so the
   badge takes the auto margin and the revoke button rides along beside it. */
.ws-perm-granted-row { gap: 10px; }
.ws-perm-granted-row .ws-perm-level-badge { margin-left: auto; }
.ws-perm-cap-row .ws-perm-revoke { margin-left: auto; }
.ws-perm-revoke {
  flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; padding: 0;
  border: 0; border-radius: 6px; background: transparent; cursor: pointer;
  color: var(--ws-ink-5);
}
.ws-perm-revoke:hover:not(:disabled) { background: rgba(192,57,43,0.1); color: #c0392b; }
.ws-perm-revoke:disabled { opacity: 0.4; cursor: default; }
.ws-perm-add-toggle {
  margin-top: 10px;
  display: inline-flex; align-items: center; gap: 6px;
  background: none; border: 0; padding: 6px 2px; cursor: pointer;
  color: var(--ws-accent); font-family: var(--ws-sans);
  font-size: 12.5px; font-weight: 500;
}
.ws-perm-add-toggle:hover { text-decoration: underline; text-underline-offset: 2px; }
.ws-perm-add-row {
  margin-top: 10px;
  display: flex; flex-wrap: wrap; align-items: center; gap: 8px;
}
.ws-perm-level-badge {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--ws-accent, #1d3d48);
  color: white;
}
.ws-perm-progress-section {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--ws-line);
}
.ws-perm-progress-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
  margin-bottom: 8px;
  padding: 0 12px;
}
.ws-perm-progress-row {
  display: grid;
  grid-template-columns: 140px auto 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--ws-ink-2);
}
.ws-perm-progress-arrow {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--ws-ink-3);
}
.ws-perm-progress-bar {
  display: block;
  height: 4px;
  background: var(--ws-line);
  border-radius: 2px;
  overflow: hidden;
  min-width: 60px;
}
.ws-perm-progress-fill {
  display: block;
  height: 100%;
  background: var(--ws-accent, #1d3d48);
  transition: width 0.2s;
}
.ws-perm-progress-count {
  font-size: 12px;
  color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ws-agent-relationships {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.ws-rel-block {
  padding: 14px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-soft);
}
.ws-rel-block-head {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4); margin-bottom: 8px;
}
.ws-rel-agent-row {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 0;
  border-bottom: 1px dashed var(--ws-line);
  font-size: 13px; color: var(--ws-ink-2);
}
.ws-rel-agent-row:last-child { border-bottom: 0; }

.ws-kpi-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
.ws-kpi-card {
  padding: 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
}
.ws-kpi-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--ws-ink-4); font-weight: 600;
}
.ws-kpi-value {
  font-family: var(--ws-serif);
  font-size: 26px; font-weight: 600;
  color: var(--ws-ink); margin-top: 4px;
}
.ws-kpi-sub { font-size: 11.5px; color: var(--ws-ink-4); }

.ws-tool-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.ws-tool-card {
  padding: 12px 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
  display: flex; align-items: center; gap: 10px;
}
.ws-tool-icon {
  width: 28px; height: 28px; border-radius: 7px;
  background: white; display: grid; place-items: center;
  border: 1px solid var(--ws-line);
  color: var(--ws-ink-3); flex-shrink: 0;
}
.ws-tool-name { font-weight: 500; font-size: 13px; color: var(--ws-ink); }
.ws-tool-perms { font-size: 11px; color: var(--ws-ink-4); }
.ws-pill-ok {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px; font-weight: 500;
  color: var(--ws-ok);
  background: rgba(47,122,78,0.08);
  border: 1px solid rgba(47,122,78,0.18);
  margin-left: auto;
}

/* ===== Settings — memory rows, groups ===== */
.ws-mem-group-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 0; width: 100%;
  border: none; background: transparent;
  cursor: pointer; font-family: var(--ws-sans);
  font-size: 12.5px; color: var(--ws-ink-3);
}
.ws-mem-group-head:hover { background: var(--ws-soft); border-radius: var(--ws-r-sm); }
.ws-mem-group-tag {
  font-weight: 600; text-transform: capitalize; color: var(--ws-ink-3);
}
.ws-mem-group-count {
  margin-left: auto; font-size: 10px; color: var(--ws-ink-5);
}
.ws-mem-row {
  display: flex; align-items: flex-start; gap: 12px;
  padding: 10px 0 10px 22px;
  border-top: 1px solid var(--ws-line);
}
.ws-mem-row:hover { background: var(--ws-soft); border-radius: var(--ws-r-sm); }
.ws-mem-key {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3); margin-bottom: 2px;
}
.ws-mem-val {
  font-size: 13px; color: var(--ws-ink-2); line-height: 1.5;
}
.ws-mem-actions {
  display: flex; gap: 2px; opacity: 0; transition: opacity 0.12s;
  flex-shrink: 0;
}
.ws-mem-row:hover .ws-mem-actions { opacity: 1; }
.ws-mem-btn {
  border: 0; background: transparent; padding: 5px;
  border-radius: 5px; color: var(--ws-ink-4);
  cursor: pointer; display: grid; place-items: center;
}
.ws-mem-btn:hover { background: var(--ws-hover); color: var(--ws-ink-2); }
.ws-mem-input {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line-2);
  border-radius: var(--ws-r-sm);
  padding: 8px 10px; font-size: 13px;
  color: var(--ws-ink); outline: none;
  font-family: var(--ws-sans);
  width: 100%;
}
.ws-mem-input:focus { border-color: var(--ws-ink-3); }
.ws-conf {
  font-size: 11px; font-weight: 600; padding: 2px 6px;
  border-radius: 999px; flex-shrink: 0;
}
.ws-conf.hi { color: var(--ws-ok); background: rgba(47,122,78,0.08); }
.ws-conf.mid { color: var(--ws-warn); background: rgba(184,112,42,0.08); }
.ws-conf.lo { color: var(--ws-err); background: rgba(184,74,62,0.08); }`;
